const gameCenter = Vue.createApp({
    setup() {
        const currentUrl = TRNMNT_helpers.parseUrl();
        const defaultValues = {
            page: 1,
            team: '',
            player: '',
            gameType: '',
            tournamentType: 'all',
            tournamentSeries: '',
            tournament: '',
            division: '',
            status: 'schedule',
        };
        const urlQueryParamStrings = {
            mode: 'gctm',
            page: 'gcp',
            team: 'gct',
            player: 'gcu',
            gameType: 'gcgt',
            tournamentType: 'gctrt',
            tournamentSeries: 'gctrs',
            tournament: 'gctr',
            division: 'gcd',
            status: 'gcs',
        };
        const state = Vue.reactive({
            teams: [],
            players: [],
            series: [],
            tournaments: [],
            mode: currentUrl.params && currentUrl.params.gctm ? currentUrl.params.gctm : TOURNAMENT_MODE,
            divisionLetters: DIVISION_LETTERS,
            isTournamentPage: false,
            isLessGamesButtonVisible: false,
            isMoreGamesButtonVisible: false,
        });
        const params = Vue.reactive({
            page: setParamStartValue('page'),
            team: setParamStartValue('team'),
            player: setParamStartValue('player'),
            gameType: setParamStartValue('gameType'),
            tournamentType: setParamStartValue('tournamentType'),
            tournamentSeries: setParamStartValue('tournamentSeries'),
            tournament: TOURNAMENT_ID ? TOURNAMENT_ID : setParamStartValue('tournament'),
            division: setParamStartValue('division'),
            status: setParamStartValue('status'),
        });
        const games = Vue.ref([]);
        const total = Vue.ref(0);

        const tournaments = Vue.computed(() => {
            let tournaments = state.tournaments;
            if (params.tournamentSeries) {
                tournaments = tournaments.filter(t => t.series_id === params.tournamentSeries);
            }
            if (params.tournamentType !== defaultValues.tournamentType) {
                tournaments = tournaments.filter(t => '' + t.min_players === params.tournamentType);
            }

            return tournaments;
        });
        const players = Vue.computed(() => {
            const tournament = state.tournaments.find(t => t.id === +params.tournament);

            return tournament
                ? state.players.filter(p => tournament.players.indexOf(p.id) !== -1)
                : state.players;
        });
        const teams = Vue.computed(() => {
            const tournament = state.tournaments.find(t => t.id === +params.tournament);

            return tournament
                ? state.teams.filter(t => tournament.teams.indexOf(t.id) !== -1)
                : state.teams;
        });
        const series = Vue.computed(() => {
            return params.tournamentType !== defaultValues.tournamentType
                ? state.series.filter(s => s.id[s.id.length - 1] === params.tournamentType)
                : state.series;
        });
        const divisions = Vue.computed(() => {
            const tournament = state.tournaments.find(t => t.id === +params.tournament);

            return tournament
                ? tournament.divisions.sort(function (a, b) {
                    if (a > b) return 1;
                    if (a == b) return 0;
                    if (a < b) return -1;
                })
                : [];
        });

        if (TOURNAMENT_ID) {
            state.isTournamentPage = true;
        }
        state.isLessGamesButtonVisible = params.page > 1;

        if (state.mode === 'group') {
            readTeams();
        } else {
            readPlayers();
        }
        readTournaments();
        readGames();

        return {
            state,
            params,
            games,

            players,
            teams,
            tournaments,
            series,
            divisions,

            onChangeMode,
            onClickLessGames,
            onClickMoreGames,
            onChangeTeam,
            onChangePlayer,
            onChangeGameType,
            onChangeTournament,
            onChangeTournamentType,
            onChangeTournamentSeries,
            onChangeDivision,
            onChangeStatus,
            onClickButtonEdit,
        }

        function onChangeMode() {
            if (state.mode === 'group') {
                !state.teams.length && readTeams();
            } else {
                !state.players.length && readPlayers();
            }
            readTournaments();

            TRNMNT_helpers.insertURLQueryParam(urlQueryParamStrings.mode, state.mode);
            setDefaultValue('page');
            setDefaultValue('team');
            setDefaultValue('player');
            setDefaultValue('gameType');
            setDefaultValue('tournamentType');
            setDefaultValue('tournament');
            setDefaultValue('division');
            setDefaultValue('status');

            readGames();
        }

        function onClickLessGames() {
            if (params.page > 1) {
                params.page -= 1;

                TRNMNT_helpers.insertURLQueryParam(urlQueryParamStrings.page, params.page);
                readGames(false, true);
            }
        }

        function onClickMoreGames() {
            params.page += 1;

            TRNMNT_helpers.insertURLQueryParam(urlQueryParamStrings.page, params.page);
            readGames(false);
        }

        function onChangeTeam() {
            if (params.team) {
                setDefaultValue('division');
            }
            TRNMNT_helpers.insertURLQueryParam(urlQueryParamStrings.team, params.team);
            setDefaultValue('page');
            readGames();
        }

        function onChangePlayer() {
            if (params.player) {
                setDefaultValue('division');
            }
            TRNMNT_helpers.insertURLQueryParam(urlQueryParamStrings.player, params.player);
            setDefaultValue('page');
            readGames();
        }

        function onChangeGameType() {
            if (params.gameType !== 'regular' || !params.tournament) {
                setDefaultValue('division');
            }
            TRNMNT_helpers.insertURLQueryParam('gcgt', params.gameType);
            setDefaultValue('page');
            readGames();
        }

        function onChangeTournament() {
            const tournament = state.tournaments.find(t => t.id === params.tournament);
            if (!tournament) {
                setDefaultValue('division');
            }

            if (params.gameType !== 'regular' || !params.tournament) {
                setDefaultValue('division');
            }
            TRNMNT_helpers.insertURLQueryParam(urlQueryParamStrings.tournament, params.tournament);
            setDefaultValue('page');
            readGames();
        }

        function onChangeTournamentType() {
            TRNMNT_helpers.insertURLQueryParam(urlQueryParamStrings.tournamentType, params.tournamentType);
            setDefaultValue('tournament');
            setDefaultValue('division');
            setDefaultValue('page');
            readGames();
        }

        function onChangeTournamentSeries() {
            TRNMNT_helpers.insertURLQueryParam(urlQueryParamStrings.tournamentSeries, params.tournamentSeries);
            setDefaultValue('tournament');
            setDefaultValue('division');
            setDefaultValue('page');
            readGames();
        }

        function onChangeDivision() {
            TRNMNT_helpers.insertURLQueryParam(urlQueryParamStrings.division, params.division);
            setDefaultValue('page');
            readGames();
        }

        function onChangeStatus(status) {
            params.status = status;

            TRNMNT_helpers.insertURLQueryParam(urlQueryParamStrings.status, params.status);
            setDefaultValue('page');
            readGames();
        }

        function onClickButtonEdit(link) {
            window.location.href = link + '/update';
        }

        function readTeams() {
            fetch(TEAMS_LIST_URL)
                .then(response => response.json())
                .then(data => {
                    state.teams = data.data.teams;
                });
        }

        function readPlayers() {
            fetch(PLAYERS_LIST_URL)
                .then(response => response.json())
                .then(data => {
                    state.players = data.data.players;
                });
        }

        function readTournaments() {
            fetch(state.mode === 'group' ? TEAMS_TOURNAMENTS_LIST_URL : PLAYERS_TOURNAMENTS_LIST_URL)
                .then(response => response.json())
                .then(data => {
                    state.series = data.data.series;
                    state.tournaments = data.data.tournaments;
                });
        }

        function readGames(reset = true, prepend = false) {
            if (reset) {
                games.value = [];
                total.value = 0;
                if (params.page === 1) {
                    state.isLessGamesButtonVisible = false;
                }
                state.isMoreGamesButtonVisible = false;
            }

            const url = state.mode === 'group' ? GROUP_GAMES_URL : VERSUS_GAMES_URL;
            const searchParams = {
                page: params.page,
            };
            if (params.team) {
                searchParams.team_id = params.team;
            }
            if (params.player) {
                searchParams.user_id = params.player;
            }
            if (params.gameType) {
                searchParams.game_type = params.gameType;
            }
            if (params.tournament) {
                searchParams.tournament_id = params.tournament;
            }
            if (params.tournamentType) {
                searchParams.tournament_type = params.tournamentType;
            }
            if (params.tournamentSeries) {
                searchParams.tournament_series = params.tournamentSeries;
            }
            if (params.division) {
                searchParams.division = params.division;
            }
            if (['schedule', 'results'].indexOf(params.status) !== -1) {
                searchParams.status = params.status;
            }

            fetch(url + '?' + new URLSearchParams(searchParams).toString())
                .then(response => response.json())
                .then(data => {
                    for (let game of data.data) {
                        if (game.home.score !== null && game.away.score !== null) {
                            const date = game.played_at ? new Date(game.played_at.date) : null;

                            game.score_string = `${game.home.score} : ${game.away.score}`;
                            game.date = date ? date.getShortDate() : '__.__.____';
                            game.time = date ? date.getTimeString() + ' МСК' : '--:--';
                        } else {
                            const date = game.planned_on ? new Date(game.planned_on.date) : null;

                            game.score_string = date ? date.getTimeString() : 'TBD';
                            game.date = date ? date.getShortDate() : '';
                            game.week_day = date ? date.getWeekDay() : '';
                        }
                    }

                    if (prepend) {
                        games.value = data.data.concat(games.value);
                    } else {
                        games.value = games.value.concat(data.data);
                    }
                    total.value = data.recordsTotal;
                    state.isMoreGamesButtonVisible = games.value.length < data.recordsTotal;
                });
        }

        function setDefaultValue(param) {
            console.log(`[GAME CENTER] Set '${param}' to default`);

            params[param] = defaultValues[param];
            TRNMNT_helpers.deleteQueryParam(urlQueryParamStrings[param]);
        }

        function setParamStartValue(param, numeric = false) {
            return currentUrl.params && currentUrl.params[urlQueryParamStrings[param]]
                ? (numeric ? +currentUrl.params[urlQueryParamStrings[param]] : currentUrl.params[urlQueryParamStrings[param]])
                : defaultValues[param];
        }
    }
});
gameCenter.mount('#gameCenter');
gameCenter.config.errorHandler = (error) => {
    console.log(error);
}
